import backgroundImg from "@/assets/login-page.png";
import { RouteTracker } from "@/components/Analytics/RouteTracker";
import { Outlet } from "react-router";

export function AuthLayout() {
  return (
    <div className="theme-light min-h-screen flex bg-white text-gray-900">
      <RouteTracker />
      {/* Lado Esquerdo - Imagem de Background */}
      <div className="hidden lg:block lg:w-[70%] relative">
        <img
          src={backgroundImg}
          alt="Login background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/30">
          <div className="flex flex-col items-start justify-end h-full p-12 text-white ">
            <h1 className="text-4xl font-bold mb-4 text-white">
              Bem vindo ao Verden
            </h1>
            <p className="text-lg max-w-xl text-white">
              Gerencie sua frota de forma inteligente e eficiente.
            </p>
          </div>
        </div>
      </div>

      <div className="w-full lg:w-[30%] flex flex-col justify-center items-center p-8 bg-white">
        <div className="w-full max-w-sm">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
